import styled from "styled-components";

export const UserAvatarActionWrapper = styled.div`
  position: relative;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UserName = styled.p`
  font-size: 12px;
  color: var(--text-color-primary);
  width: 100%;
  /* max-width: 150px; */
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin: 0;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  border-radius: 100%;
`;

export const DropdownSVGWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 14px;
  height: 14px;
  background-color: var(--theme-color-secondary);
  color: var(--text-color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  transition: all ease-in-out 0.3s;

  svg {
    width: 80%;
    height: auto;
    transform: ${props => props.$isdropdownopen ? 'rotate(-90deg)' : 'rotate(90deg)'};
    transition: transform ease-in-out 0.3s;
  }
`;

export const Avatar = styled.div`
  width: 32px;
  height: 32px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 3rem;
  background-color: var(--theme-color-tertiary);
  color: var(--theme-color-primary);
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;
  transition: all ease-in-out 0.3s;

  svg {
    width: 100%;
    height: 100%;
  }

  @media only screen and (max-width: 600px) {
    width: 30px;
    height: 30px;
  }
`;

export const AvatarImage = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;